import { doc, setDoc, getDoc, getDocs, collection, query, where, orderBy, limit, updateDoc, serverTimestamp, Timestamp } from 'firebase/firestore';
import { db } from '../../firebase';
import { Transport } from './types';

export class TransportService {
  async createTransport(transportData: Omit<Transport, 'id' | 'createdAt' | 'updatedAt'>): Promise<Transport> {
    try {
      const transportRef = doc(collection(db, 'transports'));
      const transport: Transport = {
        ...transportData,
        id: transportRef.id,
        createdAt: serverTimestamp() as Timestamp,
        updatedAt: serverTimestamp() as Timestamp,
      };
      
      await setDoc(transportRef, transport);
      return transport;
    } catch (error) {
      console.error('Chyba pri vytváraní prepravy:', error);
      throw new Error('Nepodarilo sa vytvoriť prepravu');
    }
  }

  async getTransport(transportId: string): Promise<Transport | null> {
    try {
      const transportDoc = await getDoc(doc(db, 'transports', transportId));
      if (transportDoc.exists()) {
        return transportDoc.data() as Transport;
      }
      return null;
    } catch (error) {
      console.error('Chyba pri načítaní prepravy:', error);
      throw new Error('Nepodarilo sa načítať prepravu');
    }
  }

  async updateTransport(transportId: string, updates: Partial<Transport>): Promise<void> {
    try {
      const transportRef = doc(db, 'transports', transportId);
      await updateDoc(transportRef, {
        ...updates,
        updatedAt: serverTimestamp(),
      });
    } catch (error) {
      console.error('Chyba pri aktualizácii prepravy:', error);
      throw new Error('Nepodarilo sa aktualizovať prepravu');
    }
  }

  async getTransportsByCompany(companyId: string, limitCount: number = 50): Promise<Transport[]> {
    try {
      const transportsQuery = query(
        collection(db, 'transports'),
        where('companyId', '==', companyId),
        orderBy('createdAt', 'desc'),
        limit(limitCount)
      );
      
      const querySnapshot = await getDocs(transportsQuery);
      return querySnapshot.docs.map(doc => doc.data() as Transport);
    } catch (error) {
      console.error('Chyba pri načítaní preprav firmy:', error);
      throw new Error('Nepodarilo sa načítať prepravy firmy');
    }
  }
}

export const transportService = new TransportService();

